import Utils from "../../../utility";

const initialState = {
  order: "DESC",
  sortField: "createdAt",
  offset: 1,
  take: 20,
  fromDate: null,
  toDate: null,
  propertyOwnerId: "",
  advRef: "",
};

export const b2bWalletReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case Utils.ActionName.B2B_WALLET_REPORT:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
